module.exports = __webpack_public_path__ + "img/legend.697aec95.svg";